import { gql } from '@apollo/client';
import { TypeConnectionFields } from '../../fragments';
import {
  sharedInvoiceInput,
  sharedInvoiceInputFields,
} from '../../fragments/invoice-input';
import InvoiceDocumentFinanceStateFields from '../../fragments/invoice/invoice-document-finance-state-fields';

const INVOICE_DOCUMENT_FINANCE_STATE_FIELDS = gql`
  query invoiceDocumentFinanceStateFields(
    ${sharedInvoiceInputFields}
  ) {
    invoices(
      ${sharedInvoiceInput}
    ) {
      ...TypeConnectionFields
      edges {
        cursor
        node {
          id
          ...InvoiceDocumentFinanceStateFields
        }
      }
    }
  }
  ${TypeConnectionFields}
  ${InvoiceDocumentFinanceStateFields}
`;

export default INVOICE_DOCUMENT_FINANCE_STATE_FIELDS;
